"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var THUMBNAIL_SIZES = ['high', 'medium', 'standard', 'default'];
function getThumbnail(thumbnails) {
    if (!thumbnails) {
        return undefined;
    }
    var biggestThumbByWidth = _(thumbnails).values().maxBy('width');
    var biggestAvailableSize = _(THUMBNAIL_SIZES)
        .takeWhile(function (size) { return _.has(thumbnails, size); })
        .head();
    var biggestThumbnail = biggestThumbByWidth || thumbnails[biggestAvailableSize];
    return biggestThumbnail && biggestThumbnail.url.replace(/^https?:/, '');
}
exports.default = getThumbnail;
//# sourceMappingURL=get-thumbnail.js.map